import { css } from '@emotion/react';

export const showOnlyOneError = css`
  .ant-form-item-explain [role='alert']:not(:first-child) {
    display: none;
  }
`;
